import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRightOutlined } from '@ant-design/icons';
export var EMPTY = '—';
var blank = function (value) { return value == null || value === ''; };
export function Mono(_a) {
    var children = _a.children, variant = _a.variant;
    return (_jsx("span", { className: ['cidx-mono', variant === 'id' ? 'is-id' : '', variant === 'strong' ? 'is-strong' : ''].filter(Boolean).join(' '), children: children }));
}
export function NameText(_a) {
    var children = _a.children;
    return _jsx("span", { className: "cidx-name", children: blank(children) ? EMPTY : children });
}
export function Muted(_a) {
    var children = _a.children;
    return _jsx("span", { className: "cidx-muted", children: blank(children) ? EMPTY : children });
}
export function Code(_a) {
    var children = _a.children;
    return blank(children) ? _jsx(Muted, {}) : _jsx("span", { className: "cidx-code", children: children });
}
export function Chip(_a) {
    var children = _a.children, tone = _a.tone, dot = _a.dot;
    return (_jsxs("span", { className: ['cidx-chip', tone || ''].filter(Boolean).join(' '), children: [dot ? _jsx("span", { className: "cidx-chip__dot" }) : null, blank(children) ? EMPTY : children] }));
}
export function ShowLink(_a) {
    var label = _a.label, onClick = _a.onClick, plain = _a.plain;
    return (_jsxs("button", { type: "button", className: plain ? 'cidx-row-link is-plain' : 'cidx-row-link', onClick: function (event) {
            event.stopPropagation();
            onClick();
        }, children: [_jsx("span", { children: label }), _jsx(ArrowRightOutlined, {})] }));
}
export function RowButton(_a) {
    var children = _a.children, onClick = _a.onClick, accent = _a.accent, disabled = _a.disabled;
    return (_jsx("button", { type: "button", className: accent ? 'cidx-row-btn is-accent' : 'cidx-row-btn', disabled: disabled, onClick: function (event) {
            event.stopPropagation();
            onClick();
        }, children: children }));
}
export function RowActions(_a) {
    var children = _a.children;
    return (_jsx("div", { className: "cidx-row-actions", onClick: function (event) { return event.stopPropagation(); }, children: children }));
}
export function monoColumn(column) {
    return {
        key: column.key,
        title: column.title,
        width: column.width,
        align: column.align,
        render: function (row) { return _jsx(Mono, { variant: column.variant, children: column.value(row) }); }
    };
}
export function nameColumn(column) {
    return {
        key: column.key,
        title: column.title,
        width: column.width,
        align: column.align,
        render: function (row) { return _jsx(NameText, { children: column.value(row) }); }
    };
}
export function mutedColumn(column) {
    return {
        key: column.key,
        title: column.title,
        width: column.width,
        align: column.align,
        render: function (row) { return _jsx(Muted, { children: column.value(row) }); }
    };
}
export function codeColumn(column) {
    return {
        key: column.key,
        title: column.title,
        width: column.width,
        align: column.align,
        render: function (row) { return _jsx(Code, { children: column.value(row) }); }
    };
}
export function chipColumn(column) {
    return {
        key: column.key,
        title: column.title,
        width: column.width,
        align: column.align,
        render: function (row) { return (_jsx(Chip, { tone: typeof column.tone === 'function' ? column.tone(row) : column.tone, dot: typeof column.dot === 'function' ? column.dot(row) : column.dot, children: column.value(row) })); }
    };
}
export function statusColumn(column) {
    return chipColumn({
        key: column.key || 'status',
        title: column.title,
        width: column.width || '120px',
        align: column.align,
        tone: function (row) { return (column.active(row) ? 'is-active' : 'is-inactive'); },
        dot: true,
        value: function (row) { return (column.active(row) ? column.activeLabel : column.inactiveLabel); }
    });
}
export function showColumn(column) {
    return {
        key: 'action',
        title: column.title,
        width: column.width || '96px',
        align: 'end',
        render: function (row) { return _jsx(ShowLink, { label: column.label, plain: column.plain, onClick: function () { return column.onShow(row); } }); }
    };
}
export function buttonColumn(column) {
    return {
        key: column.key || 'action',
        title: column.title,
        width: column.width || '100px',
        align: 'end',
        render: function (row) { return (_jsx(RowButton, { accent: column.accent, onClick: function () { return column.onClick(row); }, children: column.label })); }
    };
}
